import React from "react";
import "./LandingPage.css";
//------------------------Logo----------------------------------
import page1 from "./../images/page1.png";
import page2 from "./../images/page2.png";
import page3 from "./../images/page3.png";
import page4 from "./../images/page4.png";
import page5 from "./../images/page5.png";
import page6 from "./../images/page6.png";
import page7 from "./../images/page7.png";
import page8 from "./../images/page8.png";

//---------------------------------------------------------------

import { NavLink } from "react-router-dom";
//----------------------------------------------------------------

function LandingPage() {
  return (
    <div className="landingPage__container">
      <div className="all_page_logo_div">
        {/*-----------------------Page-1----------------*/}
        <div className="each_page_logo_div">
          <NavLink to="/page1" className="all_nav_links">
            <div className="page1_text">How To Open This Web-App</div>
            <img className="each_page_logo" src={page1} alt="Page1 Logo" />
          </NavLink>
        </div>
        {/*----------------------------------------------*/}
        {/*-----------------------Page-2----------------*/}
        <div className="each_page_logo_div">
          <NavLink to="/page2" className="all_nav_links">
            <div className="page2_text">
              Products Are Grouped in Different Categories
            </div>
            <img className="each_page_logo" src={page2} alt="Page2 Logo" />
          </NavLink>
        </div>
        {/*----------------------------------------------*/}
        {/*-----------------------Page-3----------------*/}
        <div className="each_page_logo_div">
          <NavLink to="/page3" className="all_nav_links">
            <div className="page3_text">
              Click “Add To Basket” To Select Products
            </div>
            <img className="each_page_logo" src={page3} alt="Page3 Logo" />
          </NavLink>
        </div>
        {/*---------------------------------------------*/}
        {/*-----------------------Page-4----------------*/}
        <div className="each_page_logo_div">
          <NavLink to="/page4" className="all_nav_links">
            <div className="page4_text">
              Edit Quantity or Remove Items From “shopping Cart” Page & Click
              “Place Order” Button
            </div>
            <img className="each_page_logo" src={page4} alt="Page4 Logo" />
          </NavLink>
        </div>
        {/*----------------------------------------------*/}
        {/*-----------------------Page-5----------------*/}
        <div className="each_page_logo_div">
          <NavLink to="/page5" className="all_nav_links">
            <div className="page5_text">
              To Place Order “Sign In” With Mobile Number & OTP Received
            </div>
            <img className="each_page_logo" src={page5} alt="Page5 Logo" />
          </NavLink>
        </div>
        {/*----------------------------------------------*/}
        {/*-----------------------Page-6----------------*/}
        <div className="each_page_logo_div">
          <NavLink to="/page6" className="all_nav_links">
            <div className="page6_text">
              Click “Send” Button To Send Your Order
            </div>
            <img className="each_page_logo" src={page6} alt="Page6 Logo" />
          </NavLink>
        </div>
        {/*----------------------------------------------*/}
        {/*-----------------------Page-7----------------*/}
        <div className="each_page_logo_div">
          <NavLink to="/page7" className="all_nav_links">
            <div className="page7_text">
              Check For “Order Successful” Message & Wait For A Few Seconds
            </div>
            <img className="each_page_logo" src={page7} alt="Page7 Logo" />
          </NavLink>
        </div>
        {/*----------------------------------------------*/}
        {/*-----------------------Page-8----------------*/}
        <div className="each_page_logo_div">
          <NavLink to="/page8" className="all_nav_links">
            <div className="page8_text">
              Open An E-Shop For Your Business Just By Sending An E-Mail To Us
            </div>
            <div className="page8a_text">
              With Few Photos & Some Details Of Your Products
            </div>
            <img className="each_page_logo" src={page8} alt="Page8 Logo" />
          </NavLink>
        </div>
        {/*----------------------------------------------*/}
      </div>
    </div>
  );
}

export default LandingPage;
